import { atom } from "recoil";
import { IMake } from "../types";

export const addStateMake = atom({
  key: "addStateMake",
  default: false,
});
export const editStateMake = atom({
  key: "editStateMake",
  default: false,
});
export const rowEditMake = atom<IMake | undefined>({
  key: "rowEditMake",
  default: undefined,
});

export const selectedRowsStateMake = atom<IMake[]>({
  key: "selectedRowsStateMake",
  default: [],
});

export const makeFilterText = atom({
  key: "makeFilterText",
  default: "",
});

export const savingMake = atom({
  key: "savingMake",
  default: false,
});
export const makeFetching = atom({
  key: "makeFetching",
  default: true,
});
